import { useQuery } from '@apollo/client';
import { useClearAccount, useCurrentAccount } from '@application/api';
import { graphql } from '@gql/gql';

export const ACCOUNT_GET_CONVERSATIONS = graphql(`
  query AccountGetConversations {
    conversations {
      id
      otherAccountId
      otherAccountFullName
      otherAccountProfileImage
      otherAccountIsDeleted
      otherAccountType
    }
  }
`);

export const useGetConversations = () => {
  const { currentAccountLoggedIn } = useCurrentAccount();
  const { redirectOnTokenErrorHandler } = useClearAccount();

  const { data, error, loading, fetchMore, refetch, startPolling, stopPolling } = useQuery(
    ACCOUNT_GET_CONVERSATIONS,
    {
      fetchPolicy: 'network-only',
      onError: redirectOnTokenErrorHandler,
      ssr: false,
      skip: !currentAccountLoggedIn,
    },
  );

  return {
    conversations: data?.conversations ?? [],
    conversationsError: error,
    conversationsLoading: loading,
    conversationsFetchMore: fetchMore,
    conversationsRefetch: refetch,
    converstationsStartPoll: startPolling,
    converstationsStopPoll: stopPolling,
  };
};
